module.exports = __webpack_public_path__ + "static/media/icon8.2d61bc05.png";